import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';
import CloseIcon from '~/icons/Close';

export const GalleryCta = styled.div.attrs({
  className:
    'absolute bg-white font-bold px-12 py-8 rounded tl-body-s text-blue-6'
})`
  bottom: 12px;
  right: 12px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    bottom: 24px;
    right: 24px;
  }
`;

export const CloseButton = styled.div.attrs({
  className: 'absolute bg-white grid justify-center m-16 m:m-32'
})`
  box-shadow: 0 6px 13px 1px rgb(24 53 88 / 10%);
  right: 0;
  top: 0;
  height: 42px;
  width: 42px;
  border-radius: 50%;
`;

export const Close = styled(CloseIcon).attrs({
  className: 'm-auto'
})`
  fill: var(--cvna-color-blue-2);
  height: 24px;
  width: 24px;
`;

export const SpinnerOverlayLoader = styled.div.attrs({
  className: 'bg-white fixed inset-0'
})`
  transition: opacity 0.5s ease-in-out;
  z-index: 9999;
`;

export const SpinnerWrapper = styled.div.attrs({
  className: 'overflow-hidden'
})`
  grid-column: 1 / 4;
  grid-row: 1 / 3;
  z-index: -1;

  &.open {
    z-index: auto;
  }
`;

export const Wrapper = styled.div.attrs({
  className: 'bg-white grid'
})`
  grid-template: 84px 84px / repeat(3, 1fr);

  .gallery-image {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  & > div:nth-child(1) {
    grid-column: 1/3;
    grid-row: 1/3;
  }
  & > div:nth-child(2) {
    grid-column: 3/4;
    grid-row: 1/2;
  }
  & > div:nth-child(3) {
    grid-column: 3/4;
    grid-row: 2/3;
  }

  @media (min-width: ${legacyBreakpoints.m}px) {
    grid-template: 290px 290px / repeat(3, 1fr);
  }
`;
